<div class="modal-header edm-modal__header">
  <h2 class="edm-modal__title">{{ getTranslate("title") }}</h2>
  <button type="button" class="edm-modal__close" [attr.aria-label]="getTranslate('close')" (click)="closeModal()">
    <i class="material-symbols-outlined">close</i>
  </button>
</div>

<form [formGroup]="authForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="modal-body edm-modal__body">

    <!-- New password -->
    <div class="auth-field" [class.is-invalid]="isFieldValid('password')">
      <label class="auth-field__label" for="inputPassword">{{ getTranslate("newPassword") }}</label>
      <div class="auth-field__control auth-field__control--with-toggle">
        <input class="form-control"
          [type]="showPassword ? 'text' : 'password'"
          id="inputPassword"
          formControlName="password"
          autocomplete="new-password"
          [attr.aria-invalid]="isFieldValid('password')"
          [attr.aria-describedby]="isFieldValid('password') ? 'passwordError' : null">
        <button type="button"
          class="auth-field__toggle"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="getTranslate(showPassword ? 'hidePassword' : 'showPassword')"
          [attr.aria-pressed]="showPassword">
          <i class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
        </button>
      </div>
      @if (password.invalid && (password.dirty || password.touched) && password.errors?.required) {
        <span class="auth-field__error" id="passwordError">
          <i class="material-symbols-outlined">error</i>
          {{ getTranslate("newPasswordError") }}
        </span>
      }
    </div>
    <!-- ./ New password -->

    <!-- Confirm password -->
    <div class="auth-field" [class.is-invalid]="isFieldValid('confirmPassword')">
      <label class="auth-field__label" for="inputConfirmPassword">{{ getTranslate("confirmPassword") }}</label>
      <div class="auth-field__control auth-field__control--with-toggle">
        <input class="form-control"
          [type]="showConfirmPassword ? 'text' : 'password'"
          id="inputConfirmPassword"
          formControlName="confirmPassword"
          autocomplete="new-password"
          [attr.aria-invalid]="isFieldValid('confirmPassword')"
          [attr.aria-describedby]="isFieldValid('confirmPassword') ? 'confirmPasswordError' : null">
        <button type="button"
          class="auth-field__toggle"
          (click)="showConfirmPassword = !showConfirmPassword"
          [attr.aria-label]="getTranslate(showConfirmPassword ? 'hidePassword' : 'showPassword')"
          [attr.aria-pressed]="showConfirmPassword">
          <i class="material-symbols-outlined">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</i>
        </button>
      </div>
      @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) {
        <span class="auth-field__error" id="confirmPasswordError">
          <i class="material-symbols-outlined">error</i>
          @if (confirmPassword.errors?.required) {
            {{ getTranslate("confirmPasswordError") }}
          } @else if (confirmPassword.value != '' && confirmPassword.errors?.MatchPassword) {
            {{ getTranslate("matchPasswordError") }}
          }
        </span>
      }
    </div>
    <!-- ./ Confirm password -->

  </div>

  <div class="modal-footer edm-modal__footer">
    <div class="auth-shell__actions">
      <button type="submit"
        [disabled]="authenticating"
        class="btn btn-primary"
        [ngClass]="buttonCustomLayoutCss()">
        @if (authenticating) {
          <mat-spinner class="auth-shell__spinner" diameter="20"></mat-spinner>
        } @else {
          {{ getTranslate("save") }}
        }
      </button>
    </div>
  </div>
</form>
